import PropTypes from 'prop-types';
import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles'
import { defineMessages, FormattedMessage } from 'react-intl';

import style from './ScheduleTitle.scss';

const localMessages = defineMessages({
  scheduleFor: {
    id: 'schedule.For',
    defaultMessage: 'Schedule for {name}',
    description: 'The schedule for string',
    values: {
      name: '',
    },
  },
  auditionsForSHS: {
    id: 'schedule.ForSHS',
    defaultMessage: 'Auditions for {name}',
    description: 'The auditions for string',
    values: {
      name: '',
    },
  },
  scheduleForGT: {
    id: 'schedule.ForGT',
    defaultMessage: 'Schedule the G&T Test for {name}',
    description: 'The Gifted and Talented schedule for string',
    values: {
      name: '',
    },
  },
});

const ScheduleTitle = ({ user }) => {
  if (!user.details || !user.details.data) {
    return null;
  }

  if (user.isGT) {
    return (
      <h1 className={style.scheduleTitle}>
        <i className={`icon-Calendar-Outline ${style.scheduleTitleIcon}`} />
        &nbsp;
        <FormattedMessage {...localMessages.scheduleForGT} values={{ name: user.firstName }} />
      </h1>
    );
  }

  if (user.isSHS) {
    return (
      <h1 className={style.scheduleTitle}>
        <i className={`icon-Calendar-Outline ${style.scheduleTitleIcon}`} />
        &nbsp;
        <FormattedMessage {...localMessages.auditionsForSHS} values={{ name: user.firstName }} />
      </h1>
    );
  }

  return (
    <h1 className={style.scheduleTitle}>
      <i className={`icon-Calendar-Outline ${style.scheduleTitleIcon}`} />
      &nbsp;
      <FormattedMessage {...localMessages.scheduleFor} values={{ name: user.firstName }} />
    </h1>
  );
};

ScheduleTitle.propTypes = {
  user: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

export default withStyles(style)(ScheduleTitle);
